import { ICreateUpdateFirmware, IGetPaginatedFirmware, IGetPaginatedFirmwareForAssign, IAssignFirmware } from 'types';
import {
	serviceGetFirmwareInfo,
	serviceCreateFirmware,
	serviceUpdateFirmware,
	serviceGetPaginatedFirmware,
	serviceDeleteFirmware,
	serviceGetPaginatedFirmwareForAssign,
	serviceGetCustomersForAssignFirmware,
	serviceGetRestaurantsByIDsCustomersForFirmware,
	serviceGetFirmwaresByIDsRestaurantsForFirmware,
	serviceAssignFirmware,
} from 'services/api/firmware';
import { createAppErrorMessage } from 'utils/helpers';

const getFirmwareInfo = async (firmwareID: string) => {
	try {
		const response = await serviceGetFirmwareInfo(firmwareID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createFirmware = async (data: ICreateUpdateFirmware) => {
	try {
		await serviceCreateFirmware(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingFirmware');
		throw new Error(errorMessage);
	}
};

const updateFirmware = async (data: ICreateUpdateFirmware) => {
	try {
		await serviceUpdateFirmware(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingFirmware');
		throw new Error(errorMessage);
	}
};

const getPaginatedFirmware = async (args: IGetPaginatedFirmware) => {
	try {
		const response = await serviceGetPaginatedFirmware(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteFirmware = async (firmwareID: string) => {
	try {
		await serviceDeleteFirmware(firmwareID);
	} catch (err) {
		throw err;
	}
};

const getPaginatedFirmwareForAssign = async (args: IGetPaginatedFirmwareForAssign) => {
	try {
		const response = await serviceGetPaginatedFirmwareForAssign(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getCustomersForAssignFirmware = async () => {
	try {
		const response = await serviceGetCustomersForAssignFirmware();
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getRestaurantsByIDsCustomersForFirmware = async (customerIDs: string[]) => {
	try {
		const response = await serviceGetRestaurantsByIDsCustomersForFirmware(customerIDs);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getRestaurantsByIDsRestaurantsForFirmware = async (restaurantIDs: string[]) => {
	try {
		const response = await serviceGetFirmwaresByIDsRestaurantsForFirmware(restaurantIDs);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const assignFirmware = async (data: IAssignFirmware[]) => {
	try {
		await serviceAssignFirmware(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAssignFirmware');
		throw new Error(errorMessage);
	}
};

export {
	getFirmwareInfo,
	createFirmware,
	updateFirmware,
	getPaginatedFirmware,
	deleteFirmware,
	getPaginatedFirmwareForAssign,
	getCustomersForAssignFirmware,
	getRestaurantsByIDsCustomersForFirmware,
	getRestaurantsByIDsRestaurantsForFirmware,
	assignFirmware,
};
